/**
 * Canonical billing route paths. The Stripe `successUrl`/`cancelUrl`/`returnUrl`
 * sent to `create_checkout_session` and `open_billing_portal` must match these
 * real pages, so define them once here and import them everywhere rather than
 * scattering '/billing' string literals that can silently drift from the routes.
 *
 * Every path here is also an entry in the backend's `allowed_redirect_urls`
 * (shared/config/configs/{dev,prod}.toml in oems_v2, exact origin+path) — adding
 * a route means adding it there too, or the portal/checkout call 403s.
 */
export const BILLING_ROUTE = '/billing'
export const BILLING_SUCCESS_ROUTE = '/billing/success'
export const BILLING_CANCEL_ROUTE = '/billing/cancel'
export const BILLING_SETTINGS_ROUTE = '/settings/billing'

/**
 * Where Stripe returns a data-API credit purchase. The allowlist matches origin + path only,
 * so the outcome rides in the query on the already-allowlisted settings page.
 */
export function creditCheckoutUrls(origin: string): { successUrl: string; cancelUrl: string } {
  const base = `${origin}${BILLING_SETTINGS_ROUTE}`
  return { successUrl: `${base}?credits=success`, cancelUrl: `${base}?credits=cancel` }
}
